if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.container = this.querySelector('[role="document"]');
      this.dialog = this.querySelector('[role="dialog"]');
      this.currentIndex = 0;
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.changeSlide(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
    }

    ensureControls() {
      if (this.previousButton || !this.dialog) return;
      this.previousButton = this.createArrow('previous', 'Previous image', '‹', -1);
      this.nextButton = this.createArrow('next', 'Next image', '›', 1);
      this.counter = document.createElement('span');
      this.counter.className = 'product-media-modal__counter';
      this.counter.setAttribute('aria-live', 'polite');
      this.counter.setAttribute('aria-atomic', 'true');
      this.dialog.append(this.previousButton, this.nextButton, this.counter);
    }

    createArrow(direction, label, symbol, step) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-media-modal__arrow product-media-modal__arrow--' + direction;
      button.setAttribute('aria-label', label);
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = symbol;
      button.append(icon);
      button.addEventListener('pointerup', (event) => event.stopPropagation());
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.changeSlide(step);
      });
      return button;
    }

    show(opener) {
      this.ensureControls();
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.mediaItems = Array.from(this.container.children).filter((element) => element.hasAttribute('data-media-id'));
      const id = this.openedBy.getAttribute('data-media-id');
      this.currentIndex = Math.max(0, this.mediaItems.findIndex((element) => element.getAttribute('data-media-id') === id));
      this.renderSlide(0);
    }

    changeSlide(step) {
      if (!this.mediaItems || this.mediaItems.length < 2) return;
      this.currentIndex = (this.currentIndex + step + this.mediaItems.length) % this.mediaItems.length;
      this.renderSlide(step);
    }

    renderSlide(direction) {
      if (!this.mediaItems.length) return;
      if (this.slideAnimation) this.slideAnimation.cancel();
      if (window.pauseAllMedia) window.pauseAllMedia();
      this.mediaItems.forEach((element, index) => element.classList.toggle('active', index === this.currentIndex));
      const activeMedia = this.mediaItems[this.currentIndex];
      this.container.scrollTop = 0;
      this.container.scrollLeft = 0;
      const hasMultiple = this.mediaItems.length > 1;
      this.previousButton.hidden = !hasMultiple;
      this.nextButton.hidden = !hasMultiple;
      this.counter.hidden = !hasMultiple;
      this.counter.textContent = (this.currentIndex + 1) + ' / ' + this.mediaItems.length;
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMedia.loadContent) activeMedia.loadContent(false);
      if (direction && activeMedia.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.slideAnimation = activeMedia.animate([
          { transform: 'translateX(' + (direction > 0 ? '48px' : '-48px') + ')', opacity: 0.4 },
          { transform: 'translateX(0)', opacity: 1 }
        ], { duration: 220, easing: 'ease-out' });
      }
    }

    hide() {
      if (this.slideAnimation) this.slideAnimation.cancel();
      super.hide();
    }
  });
}
